import React from 'react';
import { Search } from 'lucide-react';

const UiSearchField = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  inputClassName = '',
}) => {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full rounded-xl border border-gray-200 bg-white py-3 pl-10 pr-4 text-sm text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-100 ${inputClassName}`}
      />
    </div>
  );
};

export default UiSearchField;
